
import Crud from '../views/DeviceType/Crud'
import Entity from '../views/DeviceType/Add'

const routes = {
    path: '/deviceTypes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/deviceTypes/add',
            name: 'NewDeviceTypes',
            component: Entity,
            meta: {
                pageTitle: 'Device Type',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/deviceTypes'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/deviceTypes/edit/:id?',
            name: 'EditDeviceTypes',
            component: Entity,
            meta: {
                pageTitle: 'Device Type',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/deviceTypes'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/deviceTypes',
            name: 'list-deviceTypes',
            component: Crud,
            meta: {
                pageTitle: 'Device Types',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
